import { render } from "./PageNotFound.vue?vue&type=template&id=236b73d3"
const script = {}

import exportComponent from "/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__